module.exports = __webpack_public_path__ + "static/midnight-in-chernobyl-57d949a03388da26db7b508a08dc37c3.jpg";